import React, { useState, useEffect } from 'react';
import { Box, Grid, RadioGroup, FormControlLabel, Radio, TextField, Checkbox, ListItemText, Button } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import Select from '@mui/material/Select';
import axios from "../../../utils/fvAxios";
import { getToken } from '../../../utils/Token';
import useFetch from "../../../utils/useFetch";

import FormControl from "../../../components/FormControl"
import BaseURL from "../../../utils/base-uri.json";

export default function Customtab1() {
  const [age, setAge] = React.useState('');

  const [ClientList, setClientList] = useState([]);
  const [ClientTemplateList, setClientTemplateList] = useState([]);
  const [AllClientTemplateList, setAllClientTemplateList] = useState([]);

  const [clientId, setClientId] = useState("");
  const [period, setPeriod] = useState("searchAll");
  const [StatusListIds, setStatusListIds] = useState([]);
  const [BiddingIntrestListIds, setBiddingIntrestListIds] = useState([]);
  const [ClaycoBiddingIntrestListIds, setClaycoBiddingIntrestListIds] = useState([]);
  const [ProfiencyCapabilitiesListIds, setProfiencyCapabilitiesListIds] = useState([]);
  const [SitesIds, setSitesIds] = useState([]);
  const [SitesList, setSitesList] = useState([]);
  const [LocationIds, setLocationIds] = useState([]);
  const [location, setLocation] = React.useState([]);
  const { data: resps } = useFetch(
    'Client/GetBusinessUnitSiteDetails?buSiteIds=' + SitesIds
  );
  useEffect(() => {
    if (resps?.data) {
      //setLocation(resps?.data);
      let Site = resps?.data;
      if (resps?.data) {
        Site?.unshift({ businessUnitSiteId: "Any", isChecked: null, isSelected: null, siteName: "Any" });
        setLocation(Site);
      }

    }
    // ChangeCountry("Any");
  }, [resps, SitesIds]);

  const [RiskLevelId, setRiskLevelId] = useState("Any");


  const [CountryId, setCountryId] = useState("");
  const [StatesList, setStatesList] = useState([]);
  const [StatesId, setStatesId] = useState("");
  const [City, setCity] = useState("");
  const [RegionIds, setRegionIds] = useState([]);
  const [RegionList, setRegionList] = useState([]);

  const [Vid, setVid] = useState("");
  const [SuppliersId, setSuppliersId] = useState("None");
  const [Name, setName] = useState("");

  const [Minority, setMinority] = useState("Any");
  const [UnionShop, setUnionShop] = useState("Any");

  const [ModificationRate, setModificationRate] = useState("");
  const [Past3Yers, setPast3Yers] = useState("Any");
  const [DirectorName, setDirectorName] = useState("");

  const [Sort, setSort] = useState("Name");

  const [token, setToken] = useState(getToken())

  const [ClientProfiencyCapabilitiesList, setClientProfiencyCapabilitiesList] = React.useState([]);
  const [ClientProfiencyCapabilitiesListIds, setClientProfiencyCapabilitiesListIds] = React.useState([]);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  useEffect(() => {
    GetClients();
    ChangeCountry("Any");
  }, []);
  const ChangeProp = (e) => {
    setClientProfiencyCapabilitiesListIds(e);
  }
  const GetClients = async () => {
    const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
    setClientList(res?.data?.data);
    ChangeClients(res?.data?.data[0]?.value);
  }
  const ChangeClients = async (e) => {
    setClientId(e);
    const res = await axios.get("Vendor/GetVendorSearchPageLoad?clientId=" + e);
    setClientTemplateList(res?.data?.data);

    let Region = res?.data?.data?.regions?.item2;
    if (res?.data?.data?.regions?.item2) {
      Region?.unshift({ key: " ", value: "Any" });
      setRegionList(Region)
    }

    const resp = await axios.get("Vendor/GetFiltersInVendorSearch?clientId=" + e);
    setAllClientTemplateList(resp?.data?.data);
    let field = [];
    for (let i = 0; i < resp?.data?.data?.clientProfiencyCapabilities?.item2?.length; i++) {
      field.push({ headding: resp?.data?.data?.clientProfiencyCapabilities?.item2[i]?.key });
      for (let j = 0; j < resp?.data?.data?.clientProfiencyCapabilities?.item2[i]?.group?.length; j++) {
        field.push({ text: resp?.data?.data?.clientProfiencyCapabilities?.item2[i]?.group[j]?.value, value: resp?.data?.data?.clientProfiencyCapabilities?.item2[i]?.group[j]?.key });
      }
    }
    setClientProfiencyCapabilitiesList(field);

    let Site = resp?.data?.data?.bUnits?.item2;
    if (resp?.data?.data?.bUnits?.item2) {
      Site?.unshift({ key: "Any", value: "Any" });
      setSitesList(Site)
    }

    setLocationIds([]);
    setSitesIds([]);
    setBiddingIntrestListIds([]);
  };
  const ChangeCountry = async (e) => {
    setCountryId(e);
    const NewOne = e == "Any" ? "" : e;
    const res = await axios.get("Companies/GetStateSelectListItems?includeCanada=false&showIDs=false&ClientId?clientID=" + 0 + "&country=" + NewOne);
    setStatesList(res?.data?.data);
  }


  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };


  return (
    <>

      <form
        action={
          BaseURL?.baseReportUrl + "VendorPrequalificationsDetails.aspx"
        }
        method="post"
        target="_blank"
      >
        <input type="hidden" name="token" value={token} />

        <Box

          sx={{ padding: "5px", marginBottom: "10px" }}
        >
          {/* Main info */}
          <Box border={1}
            borderLeft={1}
            borderRight={1}
            borderColor="#e4e7ec"
            sx={{ background: "#fff", paddingTop: "10px", paddingBottom: "10px", marginBottom: "20px" }}>
            <span style={{ color: "#3E4A62", fontSize: "18px", fontWeight: "500", marginLeft: "10px" }}> Main Information</span>
            <hr />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>

              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Client Scope</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={clientId || ""}
                      onChange={(e) => ChangeClients(e.target.value)}
                      size="small"
                      name="clientId"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }}
                      MenuProps={MenuProps}
                    >
                      {ClientList?.map((r, i) =>
                        <MenuItem key={i} value={r?.value} title={r?.text}> {r?.text}</MenuItem>
                      )}
                    </Select>
                  </div>
                </Box>
              </Grid>

            </Grid>
            <hr />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>

              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Status Period</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div>

                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={period}
                      name="period"
                      onChange={(e) => setPeriod(e?.target?.value)}
                    >
                      <FormControlLabel value="searchAll" control={<Radio />} label="Search vendors with any status period" />
                      <FormControlLabel value="searchParticular" control={<Radio />} label="Search only vendors with recent status" />
                    </RadioGroup>
                  </div>
                </Box>
              </Grid>
            </Grid>
            <hr />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px", display: !ClientTemplateList?.statusList?.item2 ? "none" : "" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Status</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      multiple
                      size='small'
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "320px"
                      }}
                      name="statusIds"
                      value={StatusListIds || []}
                      MenuProps={MenuProps}
                      renderValue={(selected) =>
                        selected
                          .map((value) => ClientTemplateList?.statusList?.item2?.find((doc) => doc?.key === value)?.value)
                          .filter((text) => text !== undefined)
                          .join(", ")
                      }
                      onChange={(e) => setStatusListIds(e.target.value)}
                    >
                      {ClientTemplateList?.statusList?.item2?.map((r, i) => (
                        <MenuItem key={i} title={r?.value} value={r?.key}>
                          <Checkbox checked={StatusListIds?.indexOf(r?.key) > -1} label={r?.value} />
                          <ListItemText primary={r?.value} />

                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Box>
              </Grid>
            </Grid>
            <hr style={{ display: !ClientTemplateList?.statusList?.item2 ? "none" : "" }} />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px", display: clientId == 58 ? "none" : "" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Bidding Interest</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      multiple
                      size='small'
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "320px"
                      }}
                      MenuProps={MenuProps}
                      name="biddingIds"
                      value={BiddingIntrestListIds || []}
                      renderValue={(selected) =>
                        selected
                          .map((value) => AllClientTemplateList?.biddingIntrests?.item2?.find((doc) => doc?.key === value)?.value)
                          .filter((text) => text !== undefined)
                          .join(", ")
                      }
                      onChange={(e) => setBiddingIntrestListIds(e.target.value)}
                    >
                      {AllClientTemplateList?.biddingIntrests?.item2?.map((r, i) => (
                        <MenuItem key={i} title={r?.value} value={r?.key}>
                          <Checkbox checked={BiddingIntrestListIds?.indexOf(r?.key) > -1} label={r?.value} />
                          <ListItemText primary={r?.value} />

                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Box>
              </Grid>

            </Grid>
            <hr style={{ display: clientId == 58 ? "none" : "" }} hidden={AllClientTemplateList?.claycoBiddingIntrests?.item2.length === 0} />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px", display: !AllClientTemplateList?.claycoBiddingIntrests?.item2 ? "none" : "" }} hidden={AllClientTemplateList?.claycoBiddingIntrests?.item2.length === 0}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Clayco Bidding Interest</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      multiple
                      size='small'
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "320px"
                      }}
                      name="claycoBiddingInterests"
                      value={ClaycoBiddingIntrestListIds || []}
                      renderValue={(selected) =>
                        selected
                          .map((value) => AllClientTemplateList?.claycoBiddingIntrests?.item2?.find((doc) => doc?.key === value)?.value)
                          .filter((text) => text !== undefined)
                          .join(", ")
                      }
                      MenuProps={MenuProps}
                      onChange={(e) => setClaycoBiddingIntrestListIds(e.target.value)}
                    >
                      {AllClientTemplateList?.claycoBiddingIntrests?.item2?.map((r, i) => (
                        <MenuItem key={i} title={r?.value} value={r?.key}>
                          <Checkbox checked={ClaycoBiddingIntrestListIds?.indexOf(r?.key) > -1} label={r?.value} />
                          <ListItemText primary={r?.value} />

                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Box>
              </Grid>

            </Grid>
            <hr style={{ display: !AllClientTemplateList?.claycoBiddingIntrests?.item2 ? "none" : "" }} />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px", display: !AllClientTemplateList?.clientProfiencyCapabilities?.item2 ? "none" : "" }} hidden={AllClientTemplateList?.clientProfiencyCapabilities?.item2.length === 0}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Proficiency & Capabilities</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    {/* <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      multiple
                      size='small'
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                      name="proficiencyIds"
                      value={ProfiencyCapabilitiesListIds || []}
                      onChange={(e) => setProfiencyCapabilitiesListIds(e.target.value)}
                    >
                      {AllClientTemplateList?.clientProfiencyCapabilities?.item2?.map((group, i) => (
                        <optgroup label={group.key} key={i}>

                          {groupedItems?.items?.group?.map((item) => (
                            <MenuItem key={item.key} value={item.key}>
                              <Checkbox checked={ProfiencyCapabilitiesListIds?.indexOf(item.key) > -1} />
                              <ListItemText primary={item.value} />
                            </MenuItem>
                          ))
                          }
                        </optgroup>
                      ))}
                    </Select> */}
                    {/* <Select
                      label="Client Proficiency Capabilities"
                      onChange={handleChange}
                    >
                      {AllClientTemplateList?.clientProfiencyCapabilities?.item2?.map((proficiencyArea) => (
                        <optgroup label={proficiencyArea.key} key={proficiencyArea.key}>
                          {proficiencyArea?.group?.map((subProficiency) => (
                            <MenuItem key={subProficiency.key} value={subProficiency.key}>
                              {subProficiency.value}
                            </MenuItem>
                          ))}
                        </optgroup>
                      ))}
                    </Select> */}
                    <FormControl
                      name="proficiencyIds"
                      inputType={"select"}
                      multiple={true}
                      items={ClientProfiencyCapabilitiesList}
                      value={ClientProfiencyCapabilitiesListIds}
                      handleChange={(val) => ChangeProp(val)}
                      width={"100%"}
                      heighlight={"false"}
                      propwidth={true}
                    />
                  </div>
                </Box>
              </Grid>
            </Grid>
            <hr hidden={AllClientTemplateList?.clientProfiencyCapabilities?.item2.length === 0} />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px", display: !AllClientTemplateList?.bUnits?.item2 ? "none" : "" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Business Units</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      multiple
                      size='small'
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "320px"
                      }}
                      MenuProps={MenuProps}
                      name="sites"
                      value={SitesIds || []}
                      displayEmpty
                      renderValue={(selected) =>
                        selected
                          .map((value) => SitesList?.find((doc) => doc?.key === value)?.value)
                          .filter((text) => text !== undefined)
                          .join(", ")
                      }
                      onChange={(e) => setSitesIds(e.target.value)}
                    >
                      {SitesList?.map((r, i) => (
                        <MenuItem key={i} title={r?.value} value={r?.key}>
                          <Checkbox checked={SitesIds?.indexOf(r?.key) > -1} label={r?.value} />
                          <ListItemText primary={r?.value} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Box>
              </Grid>
            </Grid>
            <hr style={{ display: !SitesList ? "none" : "" }} />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px", display: !AllClientTemplateList?.bUnits?.item2 ? "none" : "" }} hidden={SitesIds.length === 0}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Locations/Sites</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      multiple
                      size='small'
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "320px"
                      }}
                      MenuProps={MenuProps}
                      name="subsite"
                      value={LocationIds || []}
                      renderValue={(selected) =>
                        selected
                          .map((value) => location?.find((doc) => doc?.businessUnitSiteId === value)?.siteName)
                          .filter((text) => text !== undefined)
                          .join(", ")
                      }
                      onChange={(e) => setLocationIds(e.target.value)}
                    >
                      {location?.map((r, i) => (
                        <MenuItem key={i} title={r?.siteName} value={r?.businessUnitSiteId}>
                          <Checkbox checked={LocationIds?.indexOf(r?.businessUnitSiteId) > -1} label={r?.siteName} />
                          <ListItemText primary={r?.siteName} />

                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Box>
              </Grid>
            </Grid>
            <hr style={{ display: !AllClientTemplateList?.bUnits?.item2 ? "none" : "" }} hidden={SitesIds.length === 0} />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px", display: !AllClientTemplateList?.templates?.item2 ? "none" : "" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Risk Level</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={RiskLevelId || ""}
                      name='clientTemplateId'
                      onChange={(e) => setRiskLevelId(e.target.value)}
                      size="small"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }}
                      MenuProps={MenuProps}
                    >
                      <MenuItem value="Any">Any</MenuItem>
                      {AllClientTemplateList?.templates?.item2?.map((r, i) =>
                        <MenuItem key={i} title={r?.value} value={r?.key} > {r?.value}</MenuItem>
                      )}
                    </Select>
                  </div>
                </Box>
              </Grid>

            </Grid>


          </Box>
          {/* location */}
          <Box border={1}
            borderLeft={1}
            borderRight={1}
            borderColor="#e4e7ec"
            sx={{ background: "#fff", paddingTop: "10px", paddingBottom: "10px", marginBottom: "20px" }}>
            <span style={{ color: "#3E4A62", fontSize: "18px", fontWeight: "500", marginLeft: "10px" }}> Location</span>
            <hr />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px", display: !ClientTemplateList?.countries?.item2 ? "none" : "" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Vendor Country</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={CountryId || ""} // Ensure CountryId is initially ""
                      name='countryName'
                      onChange={(e) => {
                        ChangeCountry(e.target.value);
                      }}
                      size="small"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }}
                      MenuProps={MenuProps}
                    >
                      <MenuItem value="Any">Any</MenuItem>
                      {ClientTemplateList?.countries?.item2?.map((r, i) =>
                        <MenuItem key={i} title={r?.value} value={r?.key}> {r?.value}</MenuItem>
                      )}
                    </Select>
                  </div>

                </Box>
              </Grid>
            </Grid>
            <hr style={{ display: !ClientTemplateList?.countries?.item2 ? "none" : "" }} />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px", display: !CountryId ? "none" : "" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Vendor State</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={StatesId || ""}
                      name='vendorStateName'
                      onChange={(e) => setStatesId(e.target.value)}
                      size="small"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }}
                      MenuProps={MenuProps}
                    >
                      {StatesList?.map((r, i) =>
                        <MenuItem key={i} title={r?.value} value={r?.key} > {r?.value}</MenuItem>
                      )}
                    </Select>
                  </div>
                </Box>
              </Grid>
            </Grid>
            <hr style={{ display: !CountryId ? "none" : "" }} />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Vendor City</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <TextField size="small"
                      sx={{

                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      name='vendorCityName'
                      value={City}
                      onChange={(e) => setCity(e?.target?.value)}
                    />
                  </div>
                </Box>
              </Grid>

            </Grid>

            <hr />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }} hidden={ClientTemplateList?.regions?.item2.length === 0}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Vendor Operating Region</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="docs-label"
                      id="docs-select"
                      multiple
                      size='small'
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "320px"
                      }}
                      name="geographicArea"
                      value={RegionIds || []}
                      renderValue={(selected) =>
                        selected
                          .map((value) => RegionList?.find((doc) => doc?.key === value)?.value)
                          .filter((text) => text !== undefined)
                          .join(", ")
                      }
                      MenuProps={MenuProps}
                      onChange={(e) => setRegionIds(e.target.value)}
                    >
                      {RegionList?.map((r, i) => (
                        <MenuItem key={i} title={r?.value} value={r?.key}>
                          <Checkbox checked={RegionIds?.indexOf(r?.key) > -1} label={r?.value} />
                          <ListItemText primary={r?.value} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Contacts */}
          <Box border={1}
            borderLeft={1}
            borderRight={1}
            borderColor="#e4e7ec"
            sx={{ background: "#fff", paddingTop: "10px", paddingBottom: "10px", marginBottom: "20px" }}>
            <span style={{ color: "#3E4A62", fontSize: "18px", fontWeight: "500", marginLeft: "10px" }}> Contacts</span>
            <hr />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Vendor Name</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <TextField size="small"
                      sx={{

                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }} id="outlined-basic" variant="outlined" placeholder='Vendor Name'
                      value={Name}
                      name='VendorName'
                      onChange={(e) => setName(e?.target?.value)} />
                  </div>
                </Box>
              </Grid>
            </Grid>
            <hr hidden={AllClientTemplateList?.contractorsOrSuppliers?.item2.length === 0} />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }} hidden={AllClientTemplateList?.contractorsOrSuppliers?.item2.length === 0}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Contractor/Supplier Type</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>

                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={SuppliersId || ""}
                      onChange={(e) => setSuppliersId(e.target.value)}
                      size="small"
                      name='clientContractId'
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }}
                      MenuProps={MenuProps}
                    >

                      <MenuItem key="1" value="None" >  None</MenuItem>
                      {AllClientTemplateList?.contractorsOrSuppliers?.item2?.map((r, i) =>
                        <MenuItem key={i} value={r?.key} title={r?.value} > {r?.value}</MenuItem>
                      )}
                    </Select>
                  </div>
                </Box>
              </Grid>
            </Grid>
            <hr />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Vendor ID</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <TextField size="small"
                      sx={{

                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }} id="outlined-basic" variant="outlined" placeholder='Vendor ID'
                      name='clientVendorRefId'
                      value={Vid}
                      onChange={(e) => setVid(e?.target?.value)} />
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Purchasing */}
          <Box border={1}
            borderLeft={1}
            borderRight={1}
            borderColor="#e4e7ec"
            sx={{ background: "#fff", paddingTop: "10px", paddingBottom: "10px", marginBottom: "20px" }}>
            <span style={{ color: "#3E4A62", fontSize: "18px", fontWeight: "500", marginLeft: "10px" }}> Purchasing</span>
            <hr />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Minority Business</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <div sx={{ width: "320px" }}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={Minority}
                      placeholder="text"
                      name='minorityBusiness'
                      size="small"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }}
                      MenuProps={MenuProps}
                      onChange={(e) => setMinority(e.target.value)}
                    >
                      <MenuItem value={"Any"}>Any</MenuItem>
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                      <MenuItem value={"No"}>No</MenuItem>
                    </Select>
                  </div>
                </Box>
              </Grid>
            </Grid>
            <hr />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Union Shop</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >

                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={UnionShop}
                    placeholder="text"
                    size="small"
                    name='unionShop'
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      width: "320px"
                    }}
                    MenuProps={MenuProps}
                    onChange={(e) => setUnionShop(e.target.value)}
                  >
                    <MenuItem value={"Any"}>Any</MenuItem>
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                  </Select>

                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Safety */}
          <Box border={1}
            borderLeft={1}
            borderRight={1}
            borderColor="#e4e7ec"
            sx={{ background: "#fff", paddingTop: "10px", paddingBottom: "10px", marginBottom: "20px" }}>
            <span style={{ color: "#3E4A62", fontSize: "18px", fontWeight: "500", marginLeft: "10px" }}> Safety</span>
            <hr />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Most current experience modification rate (less than or equal to)</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >
                  <FormControl sx={{ width: "320px" }}>
                    <TextField size="small"
                      sx={{

                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px"
                      }} id="outlined-basic" variant="outlined"
                      name='mostCurrentEMR'
                      placeholder='Most current experience modification....'
                      value={ModificationRate}
                      onChange={(e) => setModificationRate(e?.target?.value)}
                    />
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
            <hr />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Cited by OSHA in the past 3 years</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >

                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={Past3Yers}
                    placeholder="text"
                    name='citedByOsha'
                    size="small"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      width: "320px"
                    }}
                    onChange={(e) => setPast3Yers(e.target.value)}
                    MenuProps={MenuProps}
                  >
                    <MenuItem value={"Any"}>Any</MenuItem>
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                  </Select>

                </Box>
              </Grid>
            </Grid>
            <hr />

            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Safety Director Name</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >

                  <TextField size="small"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      width: "320px"
                    }} id="outlined-basic" variant="outlined" placeholder='Safety Director Name'
                    name='safetyDirector'
                    value={DirectorName}
                    onChange={(e) => setDirectorName(e?.target?.value)} />
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Report Settings */}
          <Box border={1}
            borderLeft={1}
            borderRight={1}
            borderColor="#e4e7ec"
            sx={{ background: "#fff", paddingTop: "10px", paddingBottom: "10px", marginBottom: "20px" }}>
            <span style={{ color: "#3E4A62", fontSize: "18px", fontWeight: "500", marginLeft: "10px" }}> Report Settings</span>
            <hr />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: "5px" }}>
              <Grid item xs={12} sm={4} md={5} >
                <p style={{ marginLeft: "5px", color: "#101828", fontWeight: "400", marginTop: "7px" }}>Sort By</p>
              </Grid>
              <Grid item xs={12} sm={4} md={7} >
                <Box >

                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={Sort}
                    placeholder="text"
                    size="small"
                    name='sortType'
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      width: "320px"
                    }}
                    MenuProps={MenuProps}
                    onChange={(e) => setSort(e?.target?.value)}
                  >
                    <MenuItem value={"Name"}>Name</MenuItem>
                    <MenuItem value={"Status"}>Status </MenuItem>
                    <MenuItem value={"Status Period"}>Status Period</MenuItem>
                  </Select>

                </Box>
              </Grid>
            </Grid>
          </Box>


        </Box >
        <Button type="submit" value="Submit" variant="contained" sx={{ padding: "20px", float: "right" }} >Custom Report</Button>
        <br />
      </form>
    </>
  )
}
